import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_pegasus-main/artifacts/pq5tf5rk_Untitled%20design.png";

/**
 * Pegasus Infra brand lockup.
 *
 * The source PNG is 1:1 with heavy black padding. The actual artwork (horse
 * + "PEGASUS INFRA" wordmark + tagline) occupies roughly x:15-89%, y:38-77%
 * of the source. We use an ~2:1 wrapper and position a scaled copy of the
 * image so that the artwork fills the visible container, while the extra
 * black bleed is invisible against the site's black background.
 */
export default function PegasusLogo({ className = "h-12" }) {
  return (
    <div
      className={`${className} aspect-[2/1] overflow-hidden relative select-none`}
      role="img"
      aria-label="Pegasus Infra — Turning Blueprints Into Reality"
    >
      <img
        src={LOGO_URL}
        alt=""
        aria-hidden="true"
        draggable="false"
        className="absolute max-w-none pointer-events-none"
        style={{
          height: "250%",
          width: "auto",
          top: "-95%",
          left: "-15%",
        }}
      />
    </div>
  );
}
